import importerReducers from 'src/modules/shared/importer/importerReducers';
import actions from 'src/modules/asignadorFuncion/importer/asignadorFuncionImporterActions';

export default importerReducers(actions);
